module.exports = __webpack_public_path__ + "img/title.761452e4.png";